export const SEARCH_TYPES = {
	distance: 'distance',
	state: 'state',
	country: 'country',
};

export const GOOGLE = {
	geocode_url: 'https://maps.googleapis.com/maps/api/geocode/json',
	static_url: 'https://maps.googleapis.com/maps/api/staticmap',
	map_url: 'https://www.google.com/maps/search/',
};

export const RADIUS_OPTIONS = [
	{
		value: 5,
		label: '5 miles'
	},
	{
		value: 15,
		label: '15 miles'
	},
	{
		value: 25,
		label: '25 miles'
	},
	{
		value: 35,
		label: '35 miles'
	},
	{
		value: 45,
		label: '45 miles'
	},
	{
		value: 55,
		label: '55 miles'
	},
];



// WEBPACK FOOTER //
// ./src/globals/config.js